import { BaseEntity } from "../system";

// Mirrors GPMetals.Core.Entities.ListingOptimisationStatus
export enum ListingOptimisationStatus {
  Pending = 0,
  Relisted = 1,
  Discarded = 2,
}

// Mirrors GPMetals.Core.Models.ListingOptimisation.ListingOptimisationResponse
export interface IListingOptimisation extends BaseEntity {
  partDataId: string;
  tagNumber: string | null;

  newTitle: string | null;
  newPrice: number | null;
  newFulfillmentPolicyId: string | null;
  newPaymentPolicyId: string | null;
  newReturnPolicyId: string | null;

  removeFirstImage: boolean;
  applyCategoryDefaults: boolean;

  originalTitle: string | null;
  originalPrice: number | null;
  originalFulfillmentPolicyId: string | null;
  originalPaymentPolicyId: string | null;
  originalReturnPolicyId: string | null;

  status: ListingOptimisationStatus;
}

// Mirrors GPMetals.Core.Models.ListingOptimisation.StageListingOptimisationItem
export interface IStageListingOptimisationItem {
  partDataId: string;
  newTitle?: string | null;
  newPrice?: number | null;
  newFulfillmentPolicyId?: string | null;
  newPaymentPolicyId?: string | null;
  newReturnPolicyId?: string | null;
  removeFirstImage?: boolean;
  applyCategoryDefaults?: boolean;
}
